<template>
    <div class="container">
        <section class="small-container">
            <h3 v-if="isOrderSettle == 6 || isOrderSettle == 7 || isOrderSettle == 8 || isOrderSettle == 71" class="iconfont iconxiala">订单信息<span style="color:red;font-size:12px;">(实际订单结算金额为扣除质保金之后的金额)</span></h3>
            <h3 v-if="(isOrderSettle == 5 && order.sourceType == 1) || (isOrderSettle == 3 || isOrderSettle == 1 || isOrderSettle == 10)" class="iconfont iconxiala">竣工验收信息<span style="color:red;font-size:12px;">(标*为手动，金额自动计算)</span></h3>
            <h3 v-if="isOrderSettle == 5 && order.sourceType == 2" class="iconfont iconxiala">结算信息<span style="color:red;font-size:12px;">(标*为手动，金额自动计算)</span></h3>
            <el-row class="colorLine">
                <el-col :span="10">
                    <div style="height: 1px;background: #91002c;"></div>
                </el-col>
                <el-col :span="14">
                    <div style="height: 1px;background: #003570;"></div>
                </el-col>
            </el-row>
            <div v-if="isOrderSettle == 5 && order.sourceType == 2">
                <el-form status-icon inline-message inline :model="order" :rules="orderRules" ref="order" label-width="200px" :disabled="readonly">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="结算名称：" prop="orderName" class="noMarginBottom">
                                <el-input v-model.trim="order.orderName"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入结算名称" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结算总额(不含税)：" prop="amountExclTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountExclTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结算总额(含税)：" prop="amountWithTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountWithTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="税金：" prop="taxRatioAmount" class="noMarginBottom">
                                <el-input v-model.trim="order.taxRatioAmount"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div v-if="isOrderSettle == 6 || isOrderSettle == 7 || isOrderSettle == 8 || isOrderSettle == 71">
                <el-form status-icon inline-message inline :model="order" :rules="orderRules" ref="order" label-width="200px" :disabled="readonly">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发起人："  class="noMarginBottom">
                                <el-input v-model.trim="order.promoterUserName"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入发起人" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话：" class="noMarginBottom">
                                <el-input v-model.trim="order.phone"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入联系电话" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="订单名称：" prop="orderName" class="noMarginBottom">
                                <el-input v-model.trim="order.orderName"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入订单名称" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="订单总额(不含税)：" prop="amountExclTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountExclTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="订单总额(含税)：" prop="amountWithTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountWithTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="税金：" prop="taxRatioAmount" class="noMarginBottom">
                                <el-input v-model.trim="order.taxRatioAmount"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="实际订单结算总额(不含税)：" prop="actualAmountExclTax" class="noMarginBottom">
                                <el-input v-model.trim="order.actualAmountExclTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="实际订单结算总额(含税)：" prop="actualAmountWithTax" class="noMarginBottom">
                                <el-input v-model.trim="order.actualAmountWithTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="实际税金：" prop="actualTaxRatioAmount" class="noMarginBottom">
                                <el-input v-model.trim="order.actualTaxRatioAmount"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="isZbj == 1" >
                            <el-form-item label="质保金比例(%)：" prop="zbjProportion" class="noMarginBottom">
                                <el-input v-model.number="order.zbjProportion"
                                        size="mini"
                                        class="minWidth"
                                        @input="proportion"
                                        placeholder="请输入质保金比例" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="isZbj == 0">
                            <!-- <div>无质保金</div> -->
                            <el-form-item label="质保金比例(%)：" prop="zbjProportion" class="noMarginBottom">
                                <el-input v-model.number="order.zbjProportion"
                                        size="mini"
                                        disabled
                                        class="minWidth"
                                        placeholder="无" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
             <!-- :disabled="readonly" -->
            <div  v-if="(isOrderSettle == 5 && order.sourceType == 1) || (isOrderSettle == 3 || isOrderSettle == 1 || isOrderSettle == 10)">
                <el-form status-icon inline :model="order" :rules="orderRules" ref="order" label-width="200px">
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="建筑面积(㎡)：" prop="buildingArea" class="noMarginBottom" >
                                <el-input v-model.trim="order.buildingArea"
                                        size="mini"
                                        @input="buildingAreaData"
                                        class="minWidth"
                                        placeholder="请输入建筑面积" >
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="单方：" style="margin-bottom: 0px;">
                                <el-input v-model.trim="order.buildingAreaM2"
                                            style="margin-bottom: 0px;"
                                            readonly
                                            class="minWidth"
                                            size="mini">
                                    <span slot="suffix">元/m²</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                            <el-col :span="12">
                                <el-form-item label="改造面积(㎡)：" class="noMarginBottom" >
                                    <el-input v-model.trim="order.rebuildArea"
                                            size="mini"
                                            class="minWidth"
                                            @input="rebuildAreaData"
                                            placeholder="请输入改造面积" >
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="order.rebuildAreaPerM2"
                                                style="margin-bottom: 0px;"
                                                readonly
                                                class="minWidth"
                                                size="mini">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="实际开工日期：" prop="actualStartDate" class="noMarginBottom" >
                                <el-date-picker v-model="order.actualStartDate" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="实际竣工日期：" prop="actualCompletionDate" class="noMarginBottom" >
                                <el-date-picker v-model="order.actualCompletionDate" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="验收内容：" prop="checkContent" style="margin-top: 10px;" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)" v-model="order.checkContent">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="验收结论：" prop="checkConclusion" style="margin-top: 10px;" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea" size="mini" :rows="5" :maxlength="500" placeholder="请输入内容(最多500字)" v-model="order.checkConclusion">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <!-- <el-col :span="12">
                            <el-form-item label="结算名称：" prop="orderName" class="noMarginBottom">
                                <el-input v-model.trim="order.orderName"
                                          size="mini"
                                          class="minWidth"
                                          placeholder="请输入结算名称" >
                                </el-input>
                            </el-form-item>
                        </el-col> -->
                         <el-col :span="12">
                            <el-form-item label="结算总额(不含税)：" prop="amountExclTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountExclTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结算总额(含税)：" prop="amountWithTax" class="noMarginBottom">
                                <el-input v-model.trim="order.amountWithTax"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="税金：" prop="taxRatioAmount" class="noMarginBottom">
                                <el-input v-model.trim="order.taxRatioAmount"
                                          size="mini"
                                          readonly
                                          class="minWidth"/>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </section>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.component('order',{
    name: "order",
    props: [
        //价格库清单
        'actualAmountExclTax', 'actualAmountWithTax','amountExclTax','amountWithTax',
        //新增清单
        'actualAmountExclTax2', 'actualAmountWithTax2','amountExclTax2','amountWithTax2',
        //其他字段
        'readonly','isOrderSettle','buildingAreaM2'],
    computed: {
        filterArea(){
            if(this.filterId){
                return this.area.filter(item => {
                    return this.filterId.indexOf(item.id) != -1;
                });
            }
            return [];
        },
        // buildingAreaM2 (){
        //     if (){
        //         console.log(this.buildingAreaM2)
        //     }

        // },
    },
    watch: {
        actualAmountExclTax(val){
            // debugger
            this.$set(this.order, 'actualAmountExclTax', val.toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount1", (this.order.actualAmountWithTax - this.order.actualAmountExclTax).toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount", (parseFloat(this.order.actualTaxRatioAmount1 || 0) + parseFloat(this.order.actualTaxRatioAmount2||0)).toFixed(2));
        },
        actualAmountWithTax(val){
            this.$set(this.order, 'actualAmountWithTax', val.toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount1", (this.order.actualAmountWithTax - this.order.actualAmountExclTax).toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount", (parseFloat(this.order.actualTaxRatioAmount1 || 0) + parseFloat(this.order.actualTaxRatioAmount2||0)).toFixed(2));
        },
        amountExclTax(val){
            // console.log(val,'amountExclTax')
            this.order.amountExclTax = val
            // console.log(this.order,'order')
            let data = {}
            data.amountExclTax = this.order.amountExclTax
            data.amountWithTax = this.order.amountWithTax
            data.storeDetails = this.storeDetails
            data.newDetails = this.newDetails
            // data.checkContent = this.order.checkContent
            data.buildingArea = this.order.buildingArea
            data.rebuildArea = this.order.rebuildArea
            data.actualStartDate = this.order.actualStartDate
            data.actualCompletionDate = this.order.actualCompletionDate
            data.checkContent = this.order.checkContent
            data.checkConclusion = this.order.checkConclusion
            data.orderName = this.order.orderName
            data.promoterUserName = this.order.promoterUserName
            data.phone = this.order.phone
            // data.actualStartDate = this.order.actualStartDate
            // console.log(this.order,'data')
            this.setData(data,this.order.rebuildArea)
            // console.log(val,'this.getOrderDetail()')
            // this.$set(this.order, 'amountExclTax', val.toFixed(2));
            // this.$set(this.order, "taxRatioAmount1", (this.order.amountWithTax - this.order.amountExclTax).toFixed(2));
            // this.$set(this.order, "taxRatioAmount", (parseFloat(this.order.taxRatioAmount1||0) + parseFloat(this.order.taxRatioAmount2||0)).toFixed(2));
        },
        amountWithTax(val){
            // console.log(val,'amountWithTax')
            this.order.amountWithTax = val
            // this.$set(this.order, 'amountWithTax', val.toFixed(2));
            // this.$set(this.order, "taxRatioAmount1", (this.order.amountWithTax - this.order.amountExclTax).toFixed(2));
            // this.$set(this.order, "taxRatioAmount", (parseFloat(this.order.taxRatioAmount1||0) + parseFloat(this.order.taxRatioAmount2||0)).toFixed(2));
        },
        actualAmountExclTax2(val){
            debugger
            this.$set(this.order, 'actualAmountExclTax2', val.toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount2", (this.order.actualAmountWithTax2 - this.order.actualAmountExclTax2).toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount", (parseFloat(this.order.actualTaxRatioAmount1||0) + parseFloat(this.order.actualTaxRatioAmount2||0)).toFixed(2));
        },
        actualAmountWithTax2(val){
            debugger
            this.$set(this.order, 'actualAmountWithTax2', val.toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount2", (this.order.actualAmountWithTax2 - this.order.actualAmountExclTax2).toFixed(2));
            this.$set(this.order, "actualTaxRatioAmount", (parseFloat(this.order.actualTaxRatioAmount1||0) + parseFloat(this.order.actualTaxRatioAmount2||0)).toFixed(2));
        },
        amountExclTax2(val){
            this.$set(this.order, 'amountExclTax2', val.toFixed(2));
            this.$set(this.order, "taxRatioAmount2", (this.order.amountWithTax2 - this.order.amountExclTax2).toFixed(2));
            this.$set(this.order, "taxRatioAmount", (parseFloat(this.order.taxRatioAmount1||0) + parseFloat(this.order.taxRatioAmount2||0)).toFixed(2));
        },
        amountWithTax2(val){
            this.$set(this.order, 'amountWithTax2', val.toFixed(2));
            this.$set(this.order, "taxRatioAmount2", (this.order.amountWithTax2 - this.order.amountExclTax2).toFixed(2));
            this.$set(this.order, "taxRatioAmount", (parseFloat(this.order.taxRatioAmount1||0) + parseFloat(this.order.taxRatioAmount2||0)).toFixed(2));
        },
    },

    data(){

        return {
            isZbj: '',
            warrantyDeposit: false,
            filterId: [],
            dispatchData: {
                rebuildArea: ''
            },
            storeDetails: [],
            newDetails: [],
            order:{
                orderName: '',
                amountWithTax: '',
                taxRatioAmount: '',
                amountExclTax: '',
                zbjAmountExclTax: '',
                zbjTaxRatioAmount: '',
                actualTaxRatioAmount: '',
                actualAmountExclTax: '',
                regionalCompanyId: '',
                buildingArea: '', // 建筑面积
                constructAreaPerM2: '', // 建筑面积单方
                rebuildArea: '', // 改造面积
                rebuildAreaPerM2: 0, // 改造面积单方
            },
            area:[],
            orderRules: {
                orderName: [
                    {
                        required: true,
                        message: '请输入订单名称',
                        trigger: 'blur'
                    },
                ],
                regionalCompanyId: [
                    {
                        required: true,
                        message: '请选择使用区域',
                        trigger: 'blur'
                    },
                ],
                buildingArea: [
                    {
                        required: true,
                        message: '请输入建筑面积',
                        trigger: 'blur'
                    },
                ],
                rebuildArea: [
                    {
                        required: true,
                        message: '请输入改造面积',
                        trigger: 'blur'
                    },
                ],
                actualStartDate: [
                    {
                        required: true,
                        message: '请选择实际开工日期',
                        trigger: 'blur'
                    },
                ],
                actualCompletionDate: [
                    {
                        required: true,
                        message: '请选择实际竣工日期',
                        trigger: 'blur'
                    },
                ],
                checkContent: [
                    {
                        required: true,
                        message: '请输入验收内容',
                        trigger: 'blur'
                    },
                ],
                checkConclusion: [
                    {
                        required: true,
                        message: '请输入验收结论',
                        trigger: 'blur'
                    },
                ]
            },
            treeData:[],
        }
    },
    mounted() {
        // console.log('order123',this.buildingAreaM2)
        // this.getCompanyList();
        // this.getTree();
    },
    methods:{
        proportion(val) {
            val = val / 100
            this.order.zbjAmountExclTax = (this.order.amountExclTax - (this.$root.accMul(this.order.amountExclTax, val))).toFixed(2)
            this.order.zbjAmountWithTax = (this.order.amountWithTax - (this.$root.accMul(this.order.amountWithTax, val))).toFixed(2)
            this.order.zbjTaxRatioAmount =  (this.order.zbjAmountWithTax-this.order.zbjAmountExclTax).toFixed(2)
        },
        // 建筑面积单方
        buildingAreaData(val){
            if (val == 0) {
                this.order.buildingAreaM2 = 0
            } else {
                this.order.buildingAreaM2 = Number(this.order.amountWithTax/val).toFixed(2)
            }

        },
        // 改造面积单方
        rebuildAreaData(val){
            if (val == 0) {
                this.order.rebuildAreaPerM2 = 0
            } else {
                this.order.rebuildAreaPerM2 = Number(this.order.amountWithTax/val).toFixed(2)
            }
            this.$forceUpdate()
        },
        //
        exceedingStandards(val){
            if(val == 1) {
                this.warrantyDeposit = true
            } else {
                this.warrantyDeposit = false
            }
        },
        setData(data,val){
            console.log(data,'555555555555')
            // console.log(data,'datadatadatadata')
            // if (val || val == 0) {
            // console.log(val)
            this.storeDetails = data.storeDetails
            this.newDetails = data.newDetails
            this.order.rebuildArea = val
            this.order.rebuildAreaPerM2 = Number(data.amountWithTax/val).toFixed(2)
            // } else {
            //     this.order.rebuildAreaPerM2 = 0
            // }
            if (data){
                this.order = data
                if (data.buildingArea || data.rebuildArea == 0) {
                    this.order.buildingAreaM2 = Number(data.amountWithTax/data.buildingArea).toFixed(2)
                } else {
                    this.order.buildingAreaM2 = 0
                }
                let tepData = [...data.storeDetails,...data.newDetails]
                // console.log(tepData,'tepData')
                let sum = 0;
                let sumT = 0
                tepData.forEach((item)=>{
                    if (item.amountWithTax){
                        let add = Number(item.amountWithTax/ (1+(item.taxRatio/100))).toFixed(2)
                        sum = Number(sum) + Number(add)
                    } else {
                        let add = Number((item.quantities * item.unitAmountWithTax) / (1+(item.taxRatio/100))).toFixed(2)
                        sum = Number(sum) + Number(add)
                    }

                    let addT = Number(item.quantities * item.unitAmountWithTax).toFixed(2)
                    // console.log(addT,'addT')
                    sumT = Number(sumT) + Number(addT)
                })
                this.order.amountExclTax = sum.toFixed(2)
                this.order.amountWithTax = sumT.toFixed(2)
                this.order.taxRatioAmount =  Number(sumT-sum).toFixed(2)
                return sum

            } else {
                 this.order.buildingAreaM2 = 0
            }
        },
        getTree(){
            let that = this;
            this.$root.getFunc("v1/sCompany/getCompanyTree",function (res) {
                that.treeData = res.data.data
            })
        },
        cleanForm(){
            this.order = {
                orderName: '',
                amountWithTax: '',
                taxRatioAmount: '',
                amountExclTax: '',
                actualAmountWithTax: '',
                actualTaxRatioAmount: '',
                zbjAmountExclTax: '',
                zbjTaxRatioAmount: '',
                companyId: '',
            }
        },
        submitFormPromise(formName){
          return this.submitFormFnc(formName)();
        },
        submitFormFnc(formName){
            let that = this;
            var f = function (){
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if(Array.isArray(that.$refs[formName])){
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if(valid){
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        getCompanyList(){
            let that = this;
            that.$root.postHttp('/v1/sRegionalCompany/public/getRegionalCompanyList',{
                "pageFlag": 0,
                "pageNumber": 0,
                "pageSize": 0,
                "regionalCompanyCode": "",
                "regionalCompanyName": ""
            },function (res) {
                that.area = res.data.data.list
            });
        },
        changeRegionalCompany(val){
            this.$emit('changeRegional', val);
        }
    }
})
</script>

<style lang='scss' scoped>
//@import url(); 引入公共css类

@import '../../../assets/_var.scss';
@import "../../../assets/iconfont/iconfont.css";

.container /deep/{
    margin-top: -14px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .el-message-box {
        width: 500px;
    }

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px!important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

        & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;
        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }
    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }
    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }
    .dele:hover img {
        transform: scale(1.1);
    }
    & .remarks {
        width: 95%;
    }

    & .naturalForm  {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4{
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;

    }
    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    // .attachmentForm {
    //     .el-form-item__content {
    //         // width: 250px;
    //     }
    // }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }

    .maxWidthForm {
        width: 100%;
        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .onlySupplier {
        .file-list .file-name {
            max-width: 190px!important;
        }
    }

    .el-form-item {
        width: 100%;
    }
    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content{
        line-height: 33px;
    }
}
.box-card{
    margin-bottom: 15px;
}
.minWidth{
    width: 250px;
}
.width100 {
    width: 250px;
}
h3{
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
    padding-left: 25px;
}

.iconxiala::before {
    position: absolute;
    left: 0px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}
.noMarginBottom{
    // margin-bottom: 0!important;
    margin-bottom: 10px!important;
    .tipWrap {
        position: relative;
        min-width: 250px;
        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            // background: url('../../../assets/img/detail/tip.png') no-repeat left center;
        }
    }
}

.cf:before,.cf:after {
    content:"";
    display:table;
}
.cf:after { clear:both; }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/order.vue